export const COURSE_TYPES = {
  NOVOTALK: 'Novotalk Flow',
  JUNIOR: 'Novotalk Flow Jr.',
  ACCELERATOR: 'Accelerator',
};
